// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 967) return "static/css/967.ca766cf676ef3371d619.lib.css";
	if (chunkId === 32) return "static/css/32.70632196c3feb49c9f22.css";
	// return url for filenames based on template
	return undefined;
};